"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeVariables = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyDrawFunction_1 = require("open-sankey/dist/SankeyDrawFunction");
const SankeyUtils_1 = require("open-sankey/dist/SankeyUtils");
const FreeVariables = (data, set_data, multi_selected_links, tags_selected, selected_link) => {
    const value_selected = SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, tags_selected);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', checked: value_selected && value_selected.extension ? value_selected.extension.free_visible : false, label: 'Flux libres affich\u00E9s', onChange: evt => {
                        let val = Object(selected_link.current.value);
                        multi_selected_links.current.map(d => {
                            val = d.value;
                            Object.values(tags_selected).forEach(tag => {
                                if (val[tag] === undefined) {
                                    val[tag] = {};
                                }
                                val = val[tag];
                            });
                            val.extension.free_visible = evt.target.checked;
                        });
                        if (data.show_structure !== 'structure') {
                            SankeyUtils_1.hideNullFluxNodes(data, SankeyUtils_1.getLinkValue);
                        }
                        set_data(Object.assign({}, data));
                    } })),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info" }, "Beta"))),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', checked: value_selected && value_selected.extension ? value_selected.extension.display_thin : false, label: 'Affichage structure', onChange: evt => {
                        let val = Object(selected_link.current.value);
                        multi_selected_links.current.map(d => {
                            val = d.value;
                            Object.values(tags_selected).forEach(tag => {
                                if (val[tag] === undefined) {
                                    val[tag] = {};
                                }
                                val = val[tag];
                            });
                            val.extension.display_thin = evt.target.checked;
                        });
                        set_data(Object.assign({}, data));
                    } })),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info" }, "Beta")))));
};
exports.FreeVariables = FreeVariables;
